import axios, { AxiosInstance } from 'axios'

import AppStorage from '../app-storage/AppStorage'

class Request {
  // tslint:disable-next-line:variable-name
  domain: string
  _axios: AxiosInstance
  constructor() {
    this._axios = axios.create({})
  }

  setDomain(domain) {
    this.domain = domain
  }

  setTokenForAllRequests(token) {
    this._axios.defaults.headers.common.Authorization = 'Bearer ' + token
    this._axios.defaults.headers.common['X-Bearer-Token'] = token
  }

  getTokenFromStorage() {
    return AppStorage.getItem('token')
  }

  setToken(token) {
    AppStorage.setItem('token', token)
    this.setTokenForAllRequests(token)
  }
  getToken() {
    return AppStorage.getItem('token')
  }
  apiUrl(url) {
    return this.domain + url
  }

  // generic actions
  get<T>(url, config?: any) {
    return this._axios.get<T>(this.apiUrl(url), config)
  }

  post<T>(url, data = {}, config?: any) {
    return this._axios.post<T>(this.apiUrl(url), data, config)
  }

  put<T>(url, data = {}, config?: any) {
    return this._axios.put<T>(this.apiUrl(url), data, config)
  }

  delete(url, config?: any) {
    return this._axios.delete(this.apiUrl(url), config)
  }
}

export const apiRequest = new Request()
export const request = axios
